//@flow
import React, { Fragment } from 'react';
import { Wrapper, Dot, Line } from './styledComponent';

const BreadCrumbs = (props: Props)  => {
    const { total, progress } = props
    const classActive = 'active'

    const dots = Array.from(Array(total).keys()).map(i => {
        const dotClassName = i <= progress ? classActive : '';
        const lineClassName = i < progress ? classActive : '';
        return <Fragment key={i}>
            <Dot className={dotClassName} ><img src={require('../../images/tick.png').default} /></Dot>
            {i !== total - 1 ? <Line className={lineClassName} /> : null}
        </Fragment>
    });
    return <Wrapper>
        { dots }
    </Wrapper>
}

type Props = {
    total: number, 
    progress: number
}


export default BreadCrumbs;
